export const MIN_TUBES_FOR_BALANCE = 2;

export const TUBE_TYPES = {
  PCR: 'PCR',
  NON_PCR: 'NON_PCR',
};

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: 'NOT_RUNNABLE',
  NOT_ALLOWED_CENTRIFUGE_RUNNING: 'NOT_ALLOWED_CENTRIFUGE_RUNNING',
};

export function getTimeValues(date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return [seconds, minutes, hours];
}

export function getNewTime(currentTime, rate) {
  const currentSeconds = currentTime.getSeconds();
  const newTime = new Date(currentTime.getTime());
  newTime.setSeconds(currentSeconds + rate);
  return newTime;
}

export const FRONTVIEW_SLOT_INDICES = [0, 1, 2, 10, 11];
